// Grid Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDom from 'react-dom'
import ScrollMagic from 'scrollmagic'

import Loader from '../../../common/common/loader/loader.jsx'
import Dropdown from '../../../common/form/dropdown/dropdown.jsx'
import IntlMessage from '../intl/intl_message.jsx'

class Grid extends Component {
  constructor (props) {
    super(props)

    this._scrollObj = null
    this._references = {
      loader: React.createRef()
    }
  }

  static get propTypes () {
    return {
      showLoader: PropTypes.bool,
      objectList: PropTypes.array,
      onRenderGrid: PropTypes.func,
      onPaginate: PropTypes.func,
      sort: PropTypes.string,
      sortAsc: PropTypes.bool,
      sortOptions: PropTypes.array,
      onSort: PropTypes.func,
      ignoreLoader: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      showLoader: false,
      objectList: null,
      onRenderGrid: null,
      onPaginate: null,
      sort: null,
      sortAsc: true,
      sortOptions: [],
      onSort: null,
      ignoreLoader: false
    }
  }

  componentDidMount () {
    if (this.props.onPaginate) {
      this._initLoadOnScroll()
    }
  }

  render () {
    return (
      <div className='common-grid'>
        {this._renderSort()}
        <div className='gridcont'>
          {this._renderItems()}
          {this.props.showLoader ? (
            <Loader
              ref={this._references.loader}
              hidden={!!this.props.ignoreLoader}
            />
          ) : (
            ''
          )}
        </div>
        <Loader ref={this._references.loader} hidden={!this.props.showLoader} />
      </div>
    )
  }

  /* Event Handler */
  _onChange (name, value) {
    if (this.props.onSort) {
      this.props.onSort(value, !this.props.sortAsc)
    }
  }

  _onClickSort (value) {
    if (this.props.onSort) {
      this.props.onSort(value, !this.props.sortAsc)
    }
  }

  /* Private Function */
  _renderSort () {
    if (this.props.sort) {
      return (
        <div className='gridsort'>
          <span className='label'>
            <IntlMessage ident='common.list.sortByLabel' />
          </span>
          <span className='values'>
            <Dropdown
              source={this.props.sortOptions}
              name='sortBy'
              label='common.list.sortByLabel'
              className='gridsort-dropdown sort'
              value={this.props.sort}
              onChange={this._onChange.bind(this, 'sortBy')}
            />
          </span>
          {this._renderSortIcon(this.props.sort)}
        </div>
      )
    }

    return ''
  }

  _renderSortIcon (sort) {
    return (
      <span className='iconcont'>
        <i
          className={`icon${
            this.props.sortAsc
              ? ' icon-common-downarw normal'
              : ' icon-common-uparw normal'
          }`}
          onClick={this._onClickSort.bind(this, sort)}
        />
      </span>
    )
  }

  _renderItems () {
    if (this.props.onRenderGrid) {
      if (this.props.objectList && this.props.objectList.length) {
        return this.props.objectList.map((item, idx) =>
          this.props.onRenderGrid(item, idx)
        )
      }
    }

    return ''
  }

  _initLoadOnScroll () {
    const controller = new ScrollMagic.Controller()
    this._scrollObj = new ScrollMagic.Scene({
      triggerElement: ReactDom.findDOMNode(this._references.loader.current),
      triggerHook: 'onEnter'
    })
      .addTo(controller)
      .on('enter', () => {
        if (
          this._references.loader.current &&
          !this._references.loader.current.state.active
        ) {
          this._references.loader.current.makeActive()
          window.setTimeout(() => {
            this._loadMoreData()
          }, 1000)
        }
      })
  }

  _loadMoreData () {
    if (this._references.loader.current) {
      this._references.loader.current.makeInActive()
    }

    if (this._scrollObj) {
      this._scrollObj.update()
      this.props.onPaginate()
    } else {
      this._destroyLoadOnScroll()
    }
  }

  _destroyLoadOnScroll () {
    if (this._scrollObj) {
      this._scrollObj.destroy()
      this._scrollObj = null
    }
  }
}

export default Grid
